/**
 * The card changes one contact is carrying: pictures taken, and cards already on file that are to
 * go. Neither has touched the server yet — the form applies both when it is saved, so Cancel
 * really cancels and a removal is as undoable as a typo until the moment Save is pressed.
 *
 * Its own file rather than the strip's, because the form owns this state and the strip only reads
 * and reports it.
 */
export type PendingCards = {
  /** Taken but not uploaded yet. */
  files: File[]
  /** Ids of cards on the contact that the save is to delete. */
  removedIds: string[]
}

export const NO_PENDING_CARDS: PendingCards = { files: [], removedIds: [] }

export function hasPendingCards(pending: PendingCards): boolean {
  return pending.files.length > 0 || pending.removedIds.length > 0
}
